/**
 * A Group board grouped by PERSON rather than by crew: the same payload, reshaped so every
 * schedulable person is a row in one synthetic band and each job's crew is the colour it is
 * drawn in. Board.jsx says why it is a reshape and not a second grid or query.
 *
 * Here rather than in Board.jsx because that page reads useAuth and is not rendered in the
 * tests, and the reshape has already had one bug that a test would have caught.
 */

// The one synthetic band that holds everybody. A fixed string rather than null, because
// null is already the unassigned pseudo-group's id and the two mean opposite things: "no
// crew" versus "every crew at once".
export const PEOPLE_BAND_ID = '__people__'

/** The board with one band holding everybody, in the order of `board.staff`. */
export function toPeopleBoard(b) {
  if (!b) return b
  return {
    ...b,
    // No day moves either. They say which crew somebody is on for a date, and there are no
    // crews to be on here: the day grid took anyone moved for the day out of the one band and
    // then found no band by that crew's id to put them in, so they vanished from the day view
    // unless they had a job booked, and came back at the bottom if they had. Their crew for
    // the day is still on each of their jobs.
    dayTeams: [],
    groups: [
      {
        kind: 'people',
        id: PEOPLE_BAND_ID,
        name: 'Everyone',
        subtitle: null,
        color: null,
        staffIds: (b.staff || []).map((s) => s.id),
      },
    ],
    assignments: (b.assignments || []).map((a) => ({
      ...a,
      // Kept so the cell can be painted in its crew's colour and the editor can show and
      // change which crew the job belongs to.
      crewGroupId: a.catTeamId,
      renderGroupId: PEOPLE_BAND_ID,
      // Nobody is "borrowed" on a board with one band — there is nowhere to be borrowed from.
      // The crew is on the job itself.
      borrowedFromGroupId: null,
    })),
  }
}
